import { isNil } from 'lodash';
import { useRef } from 'react';

export function Logo({ active, image, onClick }) {
  const imageRef = useRef(null);

  const dragStart = (event) => {
    console.log('darg Start');
    onClick();
  };

  const computeRatio = () => {
    if (isNil(imageRef.current)) return 1;
    const image = imageRef.current;
    const width = image.naturalWidth;
    const height = image.naturalHeight;
    console.log('width', width, 'height', height);
    return width / height;
  };

  return (
    <div
      onClick={() => {
        const ratio = computeRatio();
        onClick(ratio);
        //console.log("RATIO", aspectRatio);
      }}
      style={{ display: 'flex', justifyContent: 'center' }}
    >
      <div className={`logoItem ${active ? 'activated-item' : ''}`} draggable="true">
        <img
          ref={imageRef}
          className=""
          src={image}
          alt="avatar"
          draggable="true"
          onDragStart={(event) => {
            console.log('event', event);
            dragStart(event);
          }}
        />
      </div>
    </div>
  );
}
